var map = {
	"./avatar-child-female.svg": 43119,
	"./avatar-child-male.svg": 86376,
	"./avatar-child-other.svg": 71780,
	"./avatar-child.svg": 5367,
	"./avatar-father.svg": 57433,
	"./avatar-mother.svg": 87378,
	"./avatar-parent-female.svg": 37178,
	"./avatar-parent-in-law-female.svg": 58316,
	"./avatar-parent-in-law-male.svg": 62558,
	"./avatar-parent-in-law-other.svg": 74306,
	"./avatar-parent-male.svg": 94035,
	"./avatar-parent-other.svg": 36784,
	"./avatar-self-female.svg": 33241,
	"./avatar-self-male.svg": 22918,
	"./avatar-self.svg": 36289,
	"./avatar-spouse-female.svg": 82668,
	"./avatar-spouse-male.svg": 27500,
	"./avatar-spouse-other.svg": 35629,
	"./avatar-spouse.svg": 65170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49067;